// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Activate {\n  height: 100%;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #eceff1;\n  background: linear-gradient(to right, rgb(121, 22, 254), rgb(172, 47, 138));\n}\n\n.Activate_home {\n  margin-top: 1em;\n  color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
